import type { output, ZodType } from "zod";
import { t } from "../i18n/index.js";

/**
 * Validates against a schema from @vmeste/shared and returns localised per-field
 * messages. The schemas are the same objects the API validates with, so a rule
 * only ever exists once; only its wording lives on the client.
 */
export function validate<S extends ZodType>(
  schema: S,
  value: unknown,
  messages: Record<string, string>,
): { ok: true; value: output<S> } | { ok: false; errors: Record<string, string> } {
  const parsed = schema.safeParse(value);
  if (parsed.success) return { ok: true, value: parsed.data };

  const errors: Record<string, string> = {};
  for (const issue of parsed.error.issues) {
    const field = String(issue.path[0] ?? "_");
    // Looked up here rather than kept in a module constant, so the fallback is
    // in the language that is on now and not the one the module loaded in.
    errors[field] ??= messages[field] ?? t("auth.fieldInvalid");
  }
  return { ok: false, errors };
}
